(() => {
  if (customElements.get('akbar-diaries')) return;
  class Diaries extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('play', event => {
        this.querySelectorAll('video').forEach(video => {
          if (video !== event.target) video.pause();
        });
      }, { capture: true, signal: this.events.signal });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  }
  customElements.define('akbar-diaries', Diaries);
})();
